export default "__VITE_ASSET__cgCabTgz__"